class TimeLine extends HTMLElement {
  constructor() {
        super();
        this.swiperDom = this.querySelector(".time-line_swiper")
        this.timeButtonGroup = this.querySelectorAll(".navigation-button")
        this.index = 0
        this.mySwiper = new Swiper(this.swiperDom, {
            spaceBetween:10,
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },
            breakpoints:{
                0:{
                    slidesPerView:1.1,
                },
                768:{
                    slidesPerView:2.2,
                },
                1024:{
                    slidesPerView:2.2,
                },
                1440:{
                    slidesPerView:3.2,
                },
            },
            on: {
                slideChange: () => {
                    this.imeButtonChange(this.mySwiper.realIndex)
                }
            }
        })

        this.init()
    }

    init(){
        this.timeButtonGroup.forEach((item,index)=>{
            item.addEventListener("click",()=>{
                this.slideTo(index)
            })
        })
    }

    slideTo(index){
        this.mySwiper.slideTo(index)
        this.imeButtonChange(index)
    }

    imeButtonChange(index){
        this.timeButtonGroup[this.index].classList.remove("active")
        this.timeButtonGroup[index].classList.add("active")
        this.index = index
    }
}

reg("time-line", TimeLine);